import _ from 'lodash';

import {get, post} from 'sdk';
import {BASE_URL} from 'appConstants';
import {transformSortForStoreToSortForUrl} from 'utils/sort';
import {transformFiltersForStoreToFiltersForApi} from 'utils/filters';
import {getFormattedDateForApiOrValue} from 'utils/datetime';

export const fetchRoomTypes = ({locationRef}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/room-type/`;

  return get(url);
};

export const fetchAvailableRooms = ({
  locationRef,
  roomType,
  startDate,
  startHour,
  endDate,
  cleanupPeriodDays
}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/rooms/available/`;
  let params = {roomType, startDate, endDate, cleanupPeriodDays};

  if (startHour) {
    params['startHour'] = startHour;
  }

  return get(url, params);
};

export const fetchAvailableRoomsForBookingExtension = ({
  locationRef,
  roomType,
  extensionEnd,
  extensionCleanupPeriodDays,
  booking
}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/rooms/available-for-booking-extension/`;
  const params = {
    roomType,
    extensionEnd,
    extensionCleanupPeriodDays,
    booking
  };

  return get(url, params);
};

export const fetchRoomOptions = ({locationRef, roomType}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/rooms/room-options/`;

  return get(url, {roomType});
};

export const fetchArchivedRoomOptions = ({locationRef, roomType}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/rooms/archived-room-options/`;

  return get(url, {roomType});
};

export const fetchFloors = ({locationRef}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/rooms/floors/`;

  return get(url);
};

export const createRoom = ({
  roomType,
  roomNumber,
  floor,
  creationDate,
  locationRef,
  dummy
}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/rooms/create-room/`;

  const payload = {
    roomType,
    roomNumber,
    floor,
    creationDate,
    dummy
  };
  return post(url, payload);
};

export const archiveRoom = ({roomId, archiveDate, locationRef}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/rooms/archive-room/`;

  const payload = {
    room: roomId,
    archiveDate
  };

  return post(url, payload);
};

export const undoArchiveRoom = ({roomId, locationRef}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/rooms/undo-archive-room/`;

  const payload = {
    room: roomId
  };

  return post(url, payload);
};

export const fetchAllRooms = ({locationRef}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/rooms/`;

  return get(url);
};

export const fetchRoomDetails = ({roomId}) => {
  const url = `${BASE_URL}/v1/living/room/${roomId}/`;

  return get(url);
};

export const fetchRoomsAvailability = ({locationRef, extraGetParams}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/rooms/availability/`;

  return get(url, extraGetParams);
};

export const fetchRoomTypeFilters = ({locationRef}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/room-type/filters/`;

  return get(url);
};

export const fetchCurrentBookingOptions = ({locationRef, search}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/rooms/dashboard/current-booking-options/`;

  return get(url, {search});
};

export const fetchRoomNeighbours = ({locationRef}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/rooms/dashboard/rooms-neighbours/`;

  return get(url);
};

export const exportRoomsAvailabilityCsvInBackground = ({
  locationRef,
  filters,
  sort
}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/rooms/export-availability-csv/`;

  const normalizedFilters = _.mapValues(filters, getFormattedDateForApiOrValue);

  const params = {
    ...transformFiltersForStoreToFiltersForApi(normalizedFilters),
    ...transformSortForStoreToSortForUrl(sort)
  };

  return get(url, params);
};
